<template>
    <div class="xiangmu">

        <breadcrumb :routerList="[{to:'/dingd/myOrderList',title:'订单管理'},{title:'外销发货计划'}]" style="width:100%"/>

        <div class="h-piece h-mrt30">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                    <el-form-item label="订单编号" prop="sapCodeLike">
                        <el-input
                                v-model="formInline.sapCodeLike"
                                placeholder="请输入"
                                style="width: 2rem"
                                clearable></el-input>
                    </el-form-item>
                    <el-form-item label="产品编码" prop="materialCodeLike">
                        <el-input
                                v-model="formInline.materialCodeLike"
                                placeholder="请输入"
                                style="width: 2rem"
                                clearable></el-input>
                    </el-form-item>
                    <el-form-item label="付款方式" prop="payMethodLike">
                        <el-input
                                v-model="formInline.payMethodLike"
                                placeholder="请输入"
                                style="width: 2rem"
                                clearable></el-input>
                    </el-form-item>
                    <el-form-item class="h-formBtnOut">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="h-table h-mrt30" v-if="clickActive==1">
            <el-table
                    @selection-change="handleSelectionChange"
                    :data="tableData"
                    :span-method="objectSpanMethod"
                    stripe
					border
                    @header-click="headerClick"
                    style="width: 100%"
            >
                <el-table-column
                        type="selection"
                        width="70"
                        :label="all"
                        @header-click="headerClick"
                >
                </el-table-column>
<!--                <el-table-column-->
<!--                        :show-overflow-tooltip="true"-->
<!--                        type="index"-->
<!--                        label="序号"-->
<!--                        width="50">-->
<!--                </el-table-column>-->
                <el-table-column
                        prop="sapCode"
                        :show-overflow-tooltip="true"
                        label="订单编号"
                        width="160">
                </el-table-column>
                <el-table-column
                        prop="soldToName"
                        label="经销商"
                        :show-overflow-tooltip="true"
                        width="220">
                </el-table-column>
                <el-table-column
                        prop="proModelName"
                        label="产品型号"
                        :show-overflow-tooltip="true"
                        width="190">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="型号属性"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="isStockUp"
                        label="是否备货"
                        :show-overflow-tooltip="true"
                        width="130">
                    <template scope="scope">
                        {{scope.row.isStockUp|dictname('shifou_keyong')}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="proNumber"
                        label="产品数量"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="availableNum"
                        label="可用库存"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="syNum"
                        label="剩余库存"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="payMethod"
                        label="付款方式"
                        width="270"
                        :show-overflow-tooltip="true"
                >
                    <template scope="scope">
                        {{`现金占用：${ scope.row.jinexj } ${ scope.row.currencyCode }`}}
                        {{`信贷占用：${ scope.row.jinexd } ${ scope.row.currencyCode }`}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="审核时间"
                        :show-overflow-tooltip="true"
                        width="130">
                </el-table-column>
                <el-table-column
                        prop="cdate"
                        label="创建时间"
                        :show-overflow-tooltip="true"
                        width="130">
                </el-table-column>
                <el-table-column
                        label="操作"
                        width="140"
                        fixed="right"
                >
                    <template slot-scope="scope">
						<div style="display: flex;align-items: center;justify-content: center;">
							<el-button
							        type="text"
							        size="small"
									style="padding: 0;"
							        class="h-tableLink h-btn"
							        @click="goDetails(scope.row)">
							    查看
							</el-button>
							<el-button
									style="margin-left: 0.1rem;padding: 0;"
							        @click="send(scope.row.sapCode)"
							        type="text"
							        size="small"
							        class="h-tableLink h-btn"
							>
							    发货
							</el-button>
						</div>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-look" title="查看" @click="goDetails(scope.row)"></span>
							<span class="l-operationlist br-operation-fh" title="安排发货" @click="send(scope.row.sapCode)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="h-tableB h-mrt30">
                <div class="h-tableBL">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               style="margin-left:-20px;" @click="downloadExcel">批量导出
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="sendAll">
                        批量安排发货
                    </el-button>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile';

    export default {
        data() {
            return {
                instid: null,
                showhistory: null,
                imgflag3: false,
                orderTypeList: [],
                //用户项目
                allProjectByUser: [],
                //是否有项目
                xiangmuTab: false,
                //销售组织，下拉
                xszz: [],
                fxqd: [],
                spanArr: [],
                //表单
                formInline: {
                    sapCodeLike: '',
                    materialCodeLike: '',
                    payMethodLike: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    oid: '',
                    materialCode: '',
                    payMethod: '',
                    ids: '',
                    orderStatus: '',
                },
                all: '全部',
                //表格
                multipleSelection: [],
                tableData: [],
                sapCodes: [],
                clickActive: 1
            }
        },
        methods: {
            //查看详情跳转
            goDetails(row) {
                var instid = null;
                if (row.orderCategory == '1') {
                    instid = row.binstid;
                } else {
                    instid = row.instid;
                }
                if (row.orderCategory == '1') {
                    this.$router.push({
                        path: "/dingdmain/orderNxshenpi",
                        query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                    })
                } else {
                    this.$router.push({
                        path: "/dingdmain/orderWxshenpi",
                        query: {id: row.bid, instid: instid, taskstatus: '1', f: '1'}
                    })
                }
            },
            // 重置按钮
            resetData() {
                this.formInline.sapCodeLike = "";
                this.formInline.materialCodeLike = "";
                this.formInline.payMethodLike = "";
                this.query();
            },

            //查询该用户及所有子用户所有订单详情
            query() {
                ss.OrderMainService.selectStockPage(this.formInline).then(rd => {
                    this.tableData = rd.records;
                    this.tableData.forEach((item, index) => {
                        item.availableNum = item.availableNum || 0;
                        item.syNum = item.availableNum;
                    })
                    this.formInline.total = rd.total || 0;
                    this.getSpanArr();
                });
            },
            getSpanArr() {
                this.spanArr = [];
                this.tableData.forEach((item, index) => {
                    if (index === 0) {
                        this.spanArr.push(1);
                        this.position = 0;
                    } else {
                        if (this.tableData[index].sapCode === this.tableData[index - 1].sapCode) {
                            this.spanArr[this.position] += 1;
                            this.spanArr.push(0);
                        } else {
                            this.spanArr.push(1);
                            this.position = index;
                        }
                    }
                })
            },
            objectSpanMethod({row, column, rowIndex, columnIndex}) {

                if (column.label == '经销商' && row.orderCategory == '2') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if (column.label == '订单编号' && row.orderCategory == '2') {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

                if ((column.label == '付款方式' || column.label == '操作') &&
                    (row.status == '10' || row.orderCategory == '2')) {
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },
            //导出Excel
            downloadExcel() {
                this.$msg.confirm("确认导出?", () => {
                    var idlist = [];
                    this.multipleSelection.forEach(element => {
                        idlist.push(element.sapCode);
                    });
                    this.formInline.ids = idlist;
                    updownfile.down("/api/swyl/v1/dingdmain/getOrderExcel?ids=" + this.formInline.ids, this.formInline.ids, "get", "data");
                })
            },

            //勾选事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.multipleSelection.forEach(element => {
                    element.syNum = element.availableNum - element.proNumber;
                });
            },
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            //安排发货方法
            send(x) {
                this.$msg.confirm("确认发货?", () => {
                    ss.OrderMainService.confirmSendNew(x).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                })
            },

            //批量安排发货
            sendAll() {
                this.$msg.confirm("确认批量发货?", () => {
                    var sapIds = [];
                    this.multipleSelection.forEach(element => {
                        sapIds.push(element.sapCode);
                    });
                    this.sapCodes = sapIds;
                    ss.OrderMainService.confirmSendAll(this.sapCodes).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                })
            },
            //选择按钮
            headerClick() {

            },
        },

        created() {
            this.query();
        },

        mounted() {
        },
    }
</script>
<style scoped>
    .xiangmu > .h-piece, .h-mrt30 {
        margin: 20px;
    }

</style>
<style>
    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after{
        content: "全选";
        color:white;
        background-color: rgb(93, 172, 236);
    } */
    /* .el-table__body .el-table__row .cell {
        padding: 0;
        height: 40px;
        line-height: 40px;
    } */
</style>


